import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { NoPermissionContent } from "@/features/auth/NoPermissionContent";
import { selectPermissionDeniedPath, selectPermissions } from "@/features/auth/authSlice";
import { hasPermission } from "@/features/auth/permissions";

/**
 * Gates one route on a permission GUID.
 *
 * `permissionDeniedPath` covers the case where the client thinks it has the
 * permission but the server returned 403 — the denial is recorded against the
 * path that produced it, so an unrelated page is not blocked as a side effect.
 */
export function ProtectedRoute({ requiredPermission, children }) {
  const permissions = useSelector(selectPermissions);
  const deniedPath = useSelector(selectPermissionDeniedPath);
  const location = useLocation();

  const allowed = hasPermission(permissions, requiredPermission);
  const serverDenied = deniedPath === location.pathname;

  if (!allowed || serverDenied) {
    return <NoPermissionContent />;
  }

  return children;
}
